export const formatCurrency = (
  value: number,
  currency: 'USD',
  options?: Intl.NumberFormatOptions
) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency,
    ...options,
  }).format(value)
}

export const formatCentsToDollars = (cents?: number) => {
  if (!cents) return ''
  return formatCurrency(cents / 100, 'USD', {
    minimumFractionDigits: cents % 100 === 0 ? 0 : 2,
    style: 'decimal',
    useGrouping: false,
  })
}
